import { render } from "./TournamentCategoryCreatePage.vue?vue&type=template&id=3f21b8f8"
import script from "./TournamentCategoryCreatePage.vue?vue&type=script&lang=js"
export * from "./TournamentCategoryCreatePage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__